import * as React from 'react';
import Stack from '@mui/material/Stack';
import NavbarBreadcrumbs from './NavbarBreadcrumbs';
import CustomerLogo from "./CustomerLogo";
import UserAccountMenu from "./UserAccountMenu";
//import Badge from '@mui/material/Badge';
export default function Header() {

  return (
    <Stack
      direction="row"
      sx={{
        // display: { xs: 'none', md: 'flex' },
        width: '100%',
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'space-between',
        maxWidth: { sm: '100%', md: '100%' },
        // pt: 0.5, pb: 0.5, pl: 1, pr: 1,
        pt: 1, pl: 4, pr: 1,
        //background: 'linear-gradient(to left, #ecf6ff,  #cfe8ff)',
        // background: '#f5faff',
        //        border: '1px solid #9ad3ff',
        // border: '1px solid #cfe8fa',
        // backdropFilter: 'blur(12px)',
        // borderRadius: '10px'
      }}

    >
        <NavbarBreadcrumbs />

      <Stack direction="row" sx={{ gap: 1 }}>
        {/*<Search />*/}
        {/*<CustomDatePicker />*/}
        {/*<MenuButton showBadge aria-label="Open notifications">*/}
        {/*  <NotificationsRoundedIcon />*/}
        {/*</MenuButton>*/}
        {/*<ColorModeIconDropdown />*/}
        {/* <NotificationIcon /> */}
        {/* <Stack direction="row" sx={{ gap: 1, mt: 1, mr: 3 }}>
          <Badge color="secondary" badgeContent={loggedInUser?.totalKOLLicensesUsed} max={20000}>
            <ProductionQuantityLimitsRoundedIcon />
          </Badge>
        </Stack> */}
        {/* <Stack direction="row" sx={{ gap: 1, mt: 1 }}>
          <Badge color="secondary" badgeContent={loggedInUser?.totalKOLLicensesUsed} max={20000}>
            <ProductionQuantityLimitsRoundedIcon />
          </Badge>
          <Typography variant='body1'>
            <span ><strong>License Count : </strong></span>{loggedInUser?.totalKOLLicensesUsed}
          </Typography>
        </Stack> */}
        <CustomerLogo />
        <UserAccountMenu />
      </Stack>
    </Stack>
  );
}
